"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapCoder = void 0;
const encoded_data_1 = require("../encoded-data");
exports.MapCoder = {
    testDecode: (object) => (0, encoded_data_1.isEncodedTypeOf)(object, "Map"),
    decode: (object) => new Map(object.data),
    testEncode: (object) => object instanceof Map,
    encode: (object) => ({ ___type: "Map", data: Array.from(object.entries()) }),
};
//# sourceMappingURL=map.js.map